<template>
  <div class="amap-controls" style="min-width: 500px; min-height: 300px">
    <div ref="js-container" class="map" style="width: 700px; height: 300px">
      正在加载数据 ...
    </div>
    <!-- <el-amap vid="js-container" zoom="18" :center="center" class="map" style="width: 700px; height: 300px">
    </el-amap> -->
    <div></div>
  </div>
</template>

<script>
export default {
  name: "amapControls",
  data() {
    return {
      center: [121.424624, 31.220367],
      icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
    };
  },

  mounted() {
    // this.initAmap();
    this.$bus.$on('searchAddress',(d) => {
      this.initAmap(d);
    })
  },
  methods: {
    initAmap(searchAddress) {
        var geocoder = new AMap.Geocoder({
          city: "",
        });
        geocoder.getLocation(searchAddress, (status, result) => {
          if (status === "complete" && result.geocodes.length) {
            var lnglat = result.geocodes[0].location;
            this.center = [lnglat.lng, lnglat.lat];
            var map = new AMap.Map(this.$refs['js-container'],{
              center:this.center,
              zooms: [4,18],//设置地图级别范围
              zoom: 18,
            });
            var marker = new AMap.Marker({
                position:this.center,//位置
            });
            map.add(marker);
          } else {
            this.$Message.error("根据地址查询位置失败");
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/store/components/amapControls.vue